import { j as r } from "./atoms-v218.js";
import * as m from "./atoms-v2107.js";
import { isMedia as u, getMediaAspectRatio as f, withText as c, isDerivedByContentProps as l, withCap as p } from "./atoms-v2108.js";
import { Picture as x } from "./atoms-v233.js";
import { SlotType as S } from "./atoms-v2109.js";
function C(t) {
  return function({ contentProps: e, currentBreakpoint: n, renderCb: i, styleProps: a }) {
    const o = {
      ...u(t) ? {
        alt: e.mediaAlt,
        aspectRatio: f(a.variant, n),
        defaultSource: e.mediaSrc
      } : {}
    }, s = e[c(t)];
    if (l(t, e))
      switch (t) {
        case S.Media:
          return /* @__PURE__ */ r.jsx(x, { ...o });
        default: {
          const d = m[p(t)];
          return /* @__PURE__ */ r.jsx(d, { ...o, children: s });
        }
      }
    return typeof i == "function" ? i() : i;
  };
}
export {
  C as RenderSlot
};
